
import React, { useEffect, useState } from "react";
import "./Home";
import "@fortawesome/fontawesome-free/css/all.min.css";
import securityImg from "../assets/security.png";
import speakerImg from "../assets/Export speaker.png";
import volunteersImg from "../assets/volunteers.png";
import globalImg from "../assets/global.png";

// Social Icons & QR codes
import facebookIcon from "../assets/facebook.png";
import twitterIcon from "../assets/twitter.png";
import instagramIcon from "../assets/instagram.png";
import linkedinIcon from "../assets/linkedin.png";
import youtubeIcon from "../assets/youtube.png";
import facebookQR from "../assets/facebookQR.png";
import twitterQR from "../assets/twitterQR.png";
import instagramQR from "../assets/instagramQR.png";
import linkedinQR from "../assets/linkedinQR.png";
import youtubeQR from "../assets/youtubeQR.png";
import { useNavigate } from "react-router-dom";

import Footer from "./Footer";
import JoinModal from "./JoinModal";
import { Calendar, Clock, MapPin } from "lucide-react";
import scrollIcon from "../assets/scrollbar.png";

function HomePage() {
  const [showJoinModal, setShowJoinModal] = useState(false);
  const [showScroll, setShowScroll] = useState(false);
  const [event, setEvent] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  // API base URL
  const SERVER_BASE = process.env.REACT_APP_SERVER_BASE;
  const API_BASE = process.env.REACT_APP_API_BASE;
  const navigate = useNavigate();

  /* ================= FETCH UPCOMING EVENT ================= */
  useEffect(() => {
    const fetchUpcomingEvent = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${process.env.REACT_APP_SERVER_BASE}/api/events/upcoming`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data && data.start_datetime) {
          setEvent(data);
          const eventStartTime = new Date(data.start_datetime).getTime();
          const currentTime = new Date().getTime();
          const timeDiff = eventStartTime - currentTime;
          setRemainingTime(timeDiff > 0 ? timeDiff : 0);
        } else {
          setEvent(null);
          setRemainingTime(0);
        }
      } catch (err) {
        console.error("Error fetching event:", err);
        setEvent(null);
        setRemainingTime(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUpcomingEvent();
  }, []);

  /* ================= COUNTDOWN TIMER ================= */
  useEffect(() => {
    if (!event || !event.start_datetime) return;

    const timer = setInterval(() => {
      const eventStartTime = new Date(event.start_datetime).getTime();
      const currentTime = new Date().getTime();
      const diff = eventStartTime - currentTime;
      setRemainingTime(diff > 0 ? diff : 0);
    }, 1000);

    return () => clearInterval(timer);
  }, [event]);

  /* ================= SCROLL TO TOP ================= */
  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  /* ================= TIME FORMAT ================= */
  const formatTime = (ms) => {
    const pad = (num) => String(num).padStart(2, "0");
    const totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return {
      days: pad(days),
      hours: pad(hours),
      minutes: pad(minutes),
      seconds: pad(seconds),
    };
  };
  const timeLeft = formatTime(remainingTime);

  const isDeadlinePassed =
    event?.registration_deadline &&
    new Date(event.registration_deadline) < new Date();

  const isRegistrationOpen =
    event &&
    remainingTime > 0 &&
    !isDeadlinePassed;
  /* ================= FORMAT DATE & TIME ================= */
  const formatEventDate = (dateString) => {
    if (!dateString) return "Date TBA";
    try {
      return new Date(dateString).toDateString();
    } catch (err) {
      return "Date TBA";
    }
  };

  const formatEventTime = (dateString) => {
    if (!dateString) return "Time TBA";
    try {
      return new Date(dateString).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch (err) {
      return "Time TBA";
    }
  };

  return (
    <section>
      <div className="home-page">
        {/* Header */}
        <header className="header"></header>
        <section className="hero">
          <h1>
            Empowering Women in &nbsp;
            <span className="yellow">Cybersecurity</span>
          </h1>
          <p>
            NexGenCyberWomen (NGCW) is a community to empower and advance the
            next generation of women in cybersecurity by providing mentorship,
            training, and opportunities for growth, fostering a diverse and
            inclusive community dedicated to shaping the future of
            cybersecurity.
          </p>
          <button className="join-btn" onClick={() => setShowJoinModal(true)}>
            Join Us
          </button>
          <JoinModal
            isOpen={showJoinModal}
            onClose={() => setShowJoinModal(false)}
          />
        </section>

        <section className="section-light">
          <h2 className="event-title">What We Do</h2>
          
          <div className="cards">
            <div className="glass-card">
              <h3>Training & Mentorship</h3>
              <p>
                Access comprehensive training programs and receive guidance from 
                experienced cybersecurity professionals to advance your skills.
                {/* Access comprehensive training programs and guidance from
                experienced cybersecurity professionals. */}
              </p>
            </div>
            <div className="glass-card">
              <h3>Cybersecurity Jobs</h3>
              <p>
                Discover exciting job opportunities in the cybersecurity field, 
                connect with recruiters, and learn about career paths.
              </p>
            </div>
            <div className="glass-card">
              <h3>Networking Events</h3>
              <p>
              Attend networking events to connect with other women in cybersecurity, 
              share knowledge, and build relationships.
              </p>
            </div>
          </div>
        </section>

        {/* ================= UPCOMING EVENT ================= */}
        <section className="testimonials-container">
            <div className="eventss">Upcoming Event</div>
              <div className="countdown-container">
                {isLoading ? (
                  <p>Loading event...</p>
                ) : event ? (
                  remainingTime > 0 ? (
                    <>
                      <h2 className="event-main-title">{event.title}</h2>
                    <div className="timer-wrapper">
                      <div className="time-block">
                        <span className="number">{timeLeft.days}</span>
                        <span className="label">DAYS</span>
                      </div>

                      <div className="time-block">
                        <span className="number">{timeLeft.hours}</span>
                        <span className="label">HOURS</span>
                      </div>

                      <div className="time-block">
                        <span className="number">{timeLeft.minutes}</span>
                        <span className="label">MINS</span>
                      </div>

                      <div className="time-block">
                        <span className="number">{timeLeft.seconds}</span>
                        <span className="label">SECS</span>
                      </div>
                    </div>

                      <button
                        onClick={() =>
                          isRegistrationOpen &&
                          navigate("/event-details", { state: { event } })
                        }
                        disabled={!isRegistrationOpen}
                        className="register-btn"
                      >
                        {isDeadlinePassed
                          ? "Registration Closed"
                          : remainingTime <= 0
                          ? "Event Started"
                          : "Register Now"}
                      </button>
                    </>

                  ) : (
                    <h2>
                      <span>{event.title} - Session Started</span>
                      <br />
                      All CyberWomen Assemble!
                    </h2>
                  )
                ) : (
                  <h2>Events Coming Soon...</h2>
                )}
              </div>


          {event && event.start_datetime && (
            <div className="events-details">

              {/* Date */}
              <p>
                <Calendar style={{ color: "rgb(255, 181, 0)", marginRight: 10 }} />
                {formatEventDate(event.start_datetime)}
              </p>

              {/* Time */}
              <p>
                <Clock style={{ color: "rgb(255, 181, 0)", marginRight: 8 }} />
                {formatEventTime(event.start_datetime)}
              </p>

              {/* Venue (Only if physical or hybrid) */}
              {(event.event_type === "physical" ||
                event.event_type === "hybrid") && (
                <>
                  {event.venue_name && (
                    <p>
                      <MapPin style={{ color: "rgb(255, 181, 0)", marginRight: 8 }} />
                      {event.venue_name}
                    </p>
                  )}
                </>
              )}

              {/* Registration Deadline */}
              {event.registration_deadline && (
                <p>
                  Registration will open untill:{" "}
                  {formatEventDate(event.registration_deadline)}
                </p>
              )}

            </div>

          )}
        </section>

        {/* ================= STATS ================= */}
        <section className="stats-section">
          <div className="container stats">
            <div className="stat-card">
              <img src={volunteersImg} alt="Volunteers" />
              <h2>700+</h2>
              <p>Active Members</p>
            </div>
            <div className="stat-card">
              <img src={securityImg} alt="Security" />
              <h2>100+</h2>
              <p>Security Professionals</p>
            </div>
            <div className="stat-card">
              <img src={speakerImg} alt="Speakers" />
              <h2>50+</h2>
              <p>Guest Lecturers</p>
            </div>
            <div className="stat-card">
              <img src={globalImg} alt="Global" />
              <h2>10+</h2>
              <p>Community Connects</p>
            </div>
          </div>
        </section>

        {/* ================= CONTACT ================= */}
        <section className="social">
          <div className="social-icons-wrapper">
            <div className="events">Contact</div>
            <div className="social-logos">
              <a
                href="https://www.facebook.com/people/NexGen-Cyber-Women/61572808730765/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookIcon} alt="Facebook" />
              </a>
              <a 
              href="https://x.com/nexgenwomen" 
              target="_blank" 
              rel="noopener noreferrer"
              >
                <img src={twitterIcon} alt="Twitter" />
              </a>
              <a
                href="https://www.instagram.com/ngcyberwomen"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagramIcon} alt="Instagram" />
              </a>
              <a
                href="https://www.linkedin.com/company/nexgencyberwomen/?originalSubdomain=in"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinIcon} alt="LinkedIn" />
              </a>
              <a
                href="https://www.youtube.com/channel/UCWtcTQjt6hboL98Ew5xs_fg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={youtubeIcon} alt="YouTube" />
              </a>
            </div>
            <div className="social-qr-codes">
              <a href={facebookQR} target="_blank" rel="noopener noreferrer">
                <img src={facebookQR} alt="Facebook QR" />
              </a>
              <a href={twitterQR} target="_blank" rel="noopener noreferrer">
                <img src={twitterQR} alt="Twitter QR" />
              </a>
              <a href={instagramQR} target="_blank" rel="noopener noreferrer">
                <img src={instagramQR} alt="Instagram QR" />
              </a>
              <a href={linkedinQR} target="_blank" rel="noopener noreferrer">
                <img src={linkedinQR} alt="LinkedIn QR" />
              </a>
              <a href={youtubeQR} target="_blank" rel="noopener noreferrer">
                <img src={youtubeQR} alt="YouTube QR" />
              </a>
            </div>
          </div>
        </section>

        {/* ================= SCROLL TOP ================= */}
        <a
          href="#top"
          className={`scroll-top ${showScroll ? "visible" : ""}`}
          onClick={scrollToTop}
        >
          <img src={scrollIcon} alt="Scroll to top" className="scroll-icon" />
        </a>
      </div>
      <Footer />
    </section>
  );
}

export default HomePage;

